// extracted by mini-css-extract-plugin
export default {"container":"headerData_container__y6tKt","label":"headerData_label__GGH8h","text":"headerData_text__QFbqj","stock":"headerData_stock__mat8P"};